export const focusAreas = {
  listBuilding: {
    title: "Strategic List Building",
    icon: "GroupAdd",
    symptoms: [
      "Small or stagnant email subscriber list",
      "No clear strategy for attracting new subscribers",
      "Low-quality leads or inactive subscribers",
      "Missing opportunities to capture website visitor emails"
    ],
    impacts: [
      "Limited reach for your marketing messages",
      "Higher customer acquisition costs from paid advertising",
      "Difficulty building relationships with potential customers",
      "Reduced ability to nurture leads over time"
    ],
    solutions: [
      "Create compelling lead magnets tailored to Saskatchewan market",
      "Optimize website with strategic opt-in forms and pop-ups",
      "Develop high-converting landing pages for specific offers",
      "Implement exit-intent technology to capture leaving visitors",
      "Build partnerships for co-marketing list growth",
      "Use gated content to exchange value for email addresses",
      "Add email capture at events, in-store, and offline touchpoints"
    ],
    nextSteps: [
      "Audit current list growth sources and conversion rates",
      "Create your first lead magnet (guide, checklist, discount)",
      "Install optimized opt-in forms on key website pages",
      "Set up welcome email sequence for new subscribers"
    ],
    insight: "Your email list is your most valuable marketing asset. Email marketing has an average ROI of $42 for every $1 spent - far exceeding social media and paid ads. For Saskatchewan businesses, a quality email list lets you stay connected with customers year-round and build lasting relationships that drive repeat business."
  },
  campaignStrategy: {
    title: "Effective Campaign Strategy",
    icon: "Campaign",
    symptoms: [
      "Sending emails sporadically without a plan",
      "Low open rates and click-through rates",
      "Unsubscribes after each email sent",
      "No clear goals or purpose for email campaigns"
    ],
    impacts: [
      "Wasted opportunities to nurture leads and drive sales",
      "Subscribers forget about your business between emails",
      "Poor brand perception from irrelevant or too-frequent emails",
      "Inability to move prospects through your sales funnel"
    ],
    solutions: [
      "Develop email content calendar aligned with business goals",
      "Create campaign templates for different objectives (nurture, promote, educate)",
      "Design mobile-responsive email templates on-brand",
      "Write compelling subject lines and preview text",
      "Craft clear calls-to-action that drive desired behaviors",
      "Plan campaign sequences that tell a story over multiple emails",
      "Balance promotional and value-driven content"
    ],
    nextSteps: [
      "Define your email marketing goals and KPIs",
      "Create 30-day email content calendar",
      "Design professional email template matching your brand",
      "Write and schedule your next 3 campaigns"
    ],
    insight: "Consistency and strategy drive email success. Companies that send regular, well-planned emails see 3x higher engagement than sporadic senders. Your Saskatchewan customers want to hear from you regularly with content that's valuable and relevant - not just sales pitches. A strategic approach builds trust and keeps you top-of-mind."
  },
  automationPersonalization: {
    title: "Automation & Personalization",
    icon: "AutoAwesome",
    symptoms: [
      "Manually sending every email campaign",
      "Same generic message to entire list",
      "No follow-up after key customer actions",
      "Missing opportunities for timely, relevant communication"
    ],
    impacts: [
      "Massive time drain managing email manually",
      "Lower engagement from non-personalized content",
      "Lost sales from lack of timely follow-up",
      "Reduced effectiveness compared to competitors using automation"
    ],
    solutions: [
      "Build welcome email automation for new subscribers",
      "Create abandoned cart recovery sequences",
      "Develop lead nurture workflows based on behavior",
      "Implement re-engagement campaigns for inactive subscribers",
      "Set up birthday and anniversary automated messages",
      "Personalize content using subscriber data and preferences",
      "Use dynamic content blocks for advanced personalization",
      "Trigger emails based on website behavior and purchases"
    ],
    nextSteps: [
      "Map your ideal customer journey and touchpoints",
      "Create welcome email series (3-5 emails)",
      "Segment list by at least 2-3 key criteria",
      "Set up first behavioral trigger campaign"
    ],
    insight: "Automation and personalization transform email from a chore into a revenue-generating machine. Automated emails generate 320% more revenue than non-automated emails, and personalized emails deliver 6x higher transaction rates. For busy Saskatchewan business owners, automation lets you deliver the right message at the right time without manual effort."
  }
};
